<ng-content select="[comp-dialog-content-inner]"></ng-content>
